import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'OCTOVERSE',
    component: () => import('../components/HomeComponent.vue'),
    meta: { isPaymentRoute: false }
  },
  {
    path: '/TopUp',
    name: 'Mobile Top Up',
    component: () => import('../components/TopupComponent.vue'),
    meta: { isPaymentRoute: false }
  },
  {
    path: '/Datapack',
    name: 'Mobile Data Pack',
    component: () => import('../components/DatapackComponent.vue'),
    meta: { isPaymentRoute: false }
  },
  {
    path: '/E-giftcard',
    name: 'E-giftcard',
    component: () => import('../components/EgiftcardComponent.vue'),
    meta: { isPaymentRoute: false }
  },
  {
    path: '/giftcard/:name',
    name: 'Gift Card',
    component: () => import('../components/SinglegiftcardComponent.vue'),
    meta: { isPaymentRoute: false }
  },
  {
    path: '/news-and-promotion',
    name: 'News And Promotion',
    component: () => import('../components/NewsandpromotionComponent.vue'),
    meta: { isPaymentRoute: false }
  },
  {
    path: '/single-blog/:id',
    name: 'Single Bold',
    component: () => import('../components/SingleblogComponent.vue'),
    meta: { isPaymentRoute: false }
  },
  {
    path: '/help-faq',
    name: 'Help & FAQ',
    component: () => import('../components/HelpfaqComponent.vue'),
    meta: { isPaymentRoute: false }
  },
  {
    path: '/Order-Complete',
    name: 'Order-Complete',
    component: () => import('../components/OrderCompleteComponent.vue'),
    meta: { isPaymentRoute: true }
  },
  {
    path: '/Gift-Card-Order-Complete',
    name: 'Gift-Card-Order-Complete',
    component: () => import('../components/GiftcardCompleteComponent.vue'),
    meta: { isPaymentRoute: true }
  },
  {
    path: '/AboutUs',
    name: 'About Us',
    component: () => import('../components/AboutusComponent.vue'),
    meta: { isPaymentRoute: false }
  },
  {
    path: '/Mobile-legends',
    name: 'Mobile Legends',
    component: () => import('../components/MlbbComponent.vue'),
    meta: { isPaymentRoute: false }
  },
  {
    path: '/Razer-Gold',
    name: 'Razer-Gold',
    component: () => import('../components/RazerComponent.vue'),
    meta: { isPaymentRoute: false }
  },
  {
    path: '/Xbox-US',
    name: 'Xbox US',
    component: () => import('../components/XboxUSComponent.vue'),
    meta: { isPaymentRoute: false }
  },
  {
    path: '/Solutions',
    name: 'Solutions',
    component: () => import('../components/SolutionsComponent.vue'),
    meta: { isPaymentRoute: false }
  },
  {
    path: '/redeem-instructions/:name',
    name: 'Redeem-Instructions',
    component: () => import('../components/RedeemInstructionComponent.vue'),
    meta: { isPaymentRoute: false }
  },
]

const router = createRouter({
  mode: 'history',
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior (to) {
    if(to.hash)
    {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
  },
  routes,
  
})

export default router
